import { Handshake } from '@bizzabo/design-system';

import { BuildInAppToolId } from '../types/appTools';

export const AppToolbarAwarenessTooltipConfig = {
    [BuildInAppToolId.Messages]: {
        icon: <Handshake />,
        title: 'Network with people around you!',
        text: 'Get new perspectives on hot topics or break the ice before having a 1:1 meeting.',
        featureToggleName: 'messages-notification-awarness-test-tooltip',
    },
};
